module.exports = __webpack_public_path__ + "img/logo-fifalotto-white4-wisdombet.c85ae2b6.png";